import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_containercodes_by_shippingContainerIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { shippingContainerId: number }): 
  Promise<{ result: { Id?: number, ShippingContainerId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.shippingContainerId)) {
      $missingRequiredInParams.push('\'shippingContainerId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { shippingContainerId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ShippingContainerId?: number }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.shippingContainerId)) {
      $missingRequiredInParams.push('\'shippingContainerId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { shippingContainerId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ShippingContainerId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.shippingContainerId)) {
      $missingRequiredInParams.push('\'shippingContainerId\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      shippingContainerId: number    }) {
        if(isNil($inParams.shippingContainerId)) {
          return true; 
        }
      return false;
    }
}
